import { Tv, Clock, Film, Globe2 } from "lucide-react";

const REASONS = [
  {
    id: "anywhere",
    icon: Tv,
    title: "Watch anywhere",
    body: "Phone, laptop, tablet, smart TV. One studio, every screen.",
  },
  {
    id: "cancel",
    icon: Clock,
    title: "Cancel anytime",
    body: "No long-term contracts. Switch off in two clicks from your account.",
  },
  {
    id: "curated",
    icon: Film,
    title: "Curated by {name}",
    body: "Every film is handpicked by the studio team. No filler, no noise.",
  },
  {
    id: "subs",
    icon: Globe2,
    title: "Subtitles & multi-language",
    body: "Multiple languages, multiple captions. Watch the way you want.",
  },
];

export default function ReasonsGrid({ tenantName, accentColor = "#F59E0B", themeColor = "#7C3AED" }) {
  return (
    <section className="max-w-[1200px] mx-auto px-6 py-20" data-testid="reasons-grid">
      <div className="text-center mb-12">
        <p className="text-[11px] uppercase tracking-[0.4em] text-white/40">More reasons to subscribe</p>
        <h2 className="mt-3 font-display font-black text-3xl md:text-5xl tracking-tighter">
          Built for cinema lovers, not algorithms.
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {REASONS.map((r) => {
          const Icon = r.icon;
          return (
            <div
              key={r.id}
              className="relative group p-6 md:p-7 backdrop-blur-md bg-white/[0.03] border border-white/10 hover:border-white/20 transition-colors overflow-hidden"
              data-testid={`reason-card-${r.id}`}
            >
              <div
                className="absolute -top-12 -right-12 w-40 h-40 opacity-20 blur-3xl pointer-events-none transition-opacity group-hover:opacity-30"
                style={{ background: `radial-gradient(closest-side, ${accentColor}, transparent)` }}
              />
              <div
                className="grid place-items-center w-12 h-12 border border-white/15 mb-5"
                style={{ color: accentColor }}
              >
                <Icon className="w-5 h-5" />
              </div>
              <h3 className="font-display font-bold text-xl tracking-tight">
                {r.title.replace("{name}", tenantName)}
              </h3>
              <p className="mt-2 text-white/55 text-sm font-light leading-relaxed">
                {r.body}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
